import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, errMsg, fmtDate } from "@/lib/api";

export function CommentsTab({ onChange }) {
  const [list, setList] = useState([]);
  const [segnalati, setSegnalati] = useState(false);
  const load = useCallback(() => api.get("/admin/comments", { params: { segnalati } }).then((r) => setList(r.data)), [segnalati]);
  useEffect(() => { load(); }, [load]);
  const act = async (id, a) => {
    try { await api.post(`/admin/comments/${id}/${a}`); load(); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      <label className="flex items-center gap-2 text-sm"><Switch checked={segnalati} onCheckedChange={setSegnalati} data-testid="comments-reported-toggle" /> Solo segnalati</label>
      <p className="text-xs text-muted-foreground">Antispam attivo: limite frequenza, max 1 link, duplicati bloccati, campo trappola. Con 3 segnalazioni il commento va in revisione e sparisce dal sito.</p>
      {!list.length && <p className="text-muted-foreground">Nessun commento.</p>}
      {list.map((c) => (
        <div key={c.id} className="luma-card space-y-2 text-sm" data-testid={`admin-comment-${c.id}`}>
          <p className="text-xs text-muted-foreground">{fmtDate(c.created_at)} · {c.autore_nome} · {c.dossier_id} · stato: <b>{c.stato}</b> · segnalazioni: {c.segnalazioni.length}</p>
          <p className="whitespace-pre-line break-words">{c.testo}</p>
          <div className="flex gap-2">
            {c.stato !== "visibile" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => act(c.id, "mostra")} data-testid={`comment-show-${c.id}`}>Ripristina</Button>}
            {c.stato === "visibile" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => act(c.id, "nascondi")} data-testid={`comment-hide-${c.id}`}>Nascondi</Button>}
            <Button size="sm" variant="ghost" className="rounded-full text-destructive" onClick={() => act(c.id, "elimina")} data-testid={`comment-delete-${c.id}`}>Elimina</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
